var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"image",class:_vm.classArray},[_vm._t("default"),_vm._v(" "),_c('img',{class:{ 'is-rounded': _vm.isRounded, 'backgrounded': _vm.hasBackground },attrs:{"src":_vm.src,"alt":_vm.alt}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69b59bae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/image.vue
// module id = null
// module chunks = 